<div class="w-100 d-block">
  <ng-content></ng-content>
  <ng-template #loaingevent>
    <nb-alert outline="primary" class="w-100" #loaingevent>
      <!-- Change this to standealone -->
      <!-- <ngx-placeholder type="event"></ngx-placeholder> -->
    </nb-alert>
  </ng-template>
  <div>
    @for (event of filteredEvents(); track event.id) {
      <nb-alert
        [outline]="outline()"
        [status]="outline()"
        [class]="[11, 31].includes(event.course_id) ? 'w-100' : 'w-100 pointer'"
        (click)="viewEvent(event.id)"
      >
        <div class="d-flex">
          <div class="flex-shrink-0">
            <nb-icon
              [icon]="filter().key != 'pastrecording' ? 'calendar' : 'play'"
              pack="mirasee"
              size="medium"
              [status]="filter().key != 'pastrecording' ? 'basic' : 'primary'"
              class="mt-1"
            ></nb-icon>
          </div>
          <div class="flex-grow-1 ms-3">
            <p
              class="mb-0"
              [innerHTML]="event.name | highlight: searchField()"
            ></p>
            <p class="text-disabled paragraph-2 mb-1">
              {{ event.datetime | dateFormat: "dddd, MMMM D, YYYY h:mm A" }} EST
            </p>
            @if (
              event.options.location &&
              filter().key != "pastrecording" &&
              filter().key != "past"
            ) {
              <p class="mb-0 mt-2 event-link">
                Join here:
                <a
                  href="{{ event.options.location }}"
                  target="_blank"
                  class="btn-link text-underline"
                  [innerHTML]="
                    event.options.location | highlight: searchField()
                  "
                ></a>
              </p>
            }
            <p
              class="mb-0 mt-2 event-topic"
              [innerHTML]="event.topic | highlight: searchField()"
            ></p>
          </div>
        </div>
        @if (link() && link().text) {
          <p class="mb-0 ms-4 ps-1 mt-2">
            <a
              [routerLink]="[
                course().slug == 'aip' || course().slug == 'aces'
                  ? 'courses'
                  : 'course',
                course().slug,
                'events',
              ]"
              href="javascript:void(false)"
              class="pointer {{ link().color }} paragraph"
              [innerHTML]="link().text | highlight: searchField()"
            ></a>
          </p>
        }
      </nb-alert>
    } @empty {
      <nb-alert
        [outline]="outline()"
        status="basic"
        class="w-100 bg-transparent"
      >
        <div class="d-flex">
          <div class="flex-shrink-0">
            <nb-icon icon="calendar" pack="mirasee" size="medium"></nb-icon>
          </div>
          <div class="flex-grow-1 ms-3">
            <p class="mb-0">No event</p>
          </div>
        </div>
        @if (link()) {
          <p class="mb-0 ms-4 ps-1 mt-2">
            <a
              [routerLink]="[basepath, course().slug, 'events']"
              class="pointer {{ link().color }} paragraph"
              >View All Events</a
            >
          </p>
        }
      </nb-alert>
    }
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
